<template>
  <roe-error-message :field="design.employer_other_dollar_maximum">
    <roe-radio-input
      v-model="design.$model.employer_other_dollar_maximum"
      @change="resetAttributes(design, 'employer_other_dollar_maximum')"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import ResetDesignAttributesMixin from "@/components/_shared/inputs/design/_mixins/ResetDesignAttributesMixin";
export default {
  name: "RoeEmployerOtherDollarMaximumRadio",
  mixins: [ResetDesignAttributesMixin],
  components: { RoeRadioInput, RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
